import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'iconService'
})
export class IconServicePipe implements PipeTransform {

  transform(value: any, args?: any): any {
      let icon = '';
      switch (value){
          case 'whatsup':
              icon = 'fa fa-whatsapp';
              break;
          case 'beeztel':
              icon = 'fa fa-phone';
              break;
          case 'chacon_sms':
          case 'agile_sms':
              icon = 'fa fa-comments';
              break;
          default:
              icon = 'fa fa-database';
              break;
      }

      return '<i class="' + icon + '" ></i>';
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_services/pipe/icon-service.pipe.ts